// Core
import { createApp, h } from 'vue'
import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import { InertiaProgress } from '@inertiajs/progress'
import { createGtm } from '@gtm-support/vue-gtm';
import route from 'ziggy'
import moment from "moment";

// Base setup
const el = document.getElementById('app');
InertiaProgress.init();

createInertiaApp({
    resolve: name => import(`./Pages/${name}`), // vs require
    setup({ el, app, props, plugin }) {

        const vueApp = createApp({ render: () => h(app, props) })

        const Ziggy = {
            ...props.initialPage.props.ziggy,
            location: window.location
        }

        vueApp.config.globalProperties.$translations = props.initialPage.props.__translations;
        vueApp.config.globalProperties.$primaryMenu = props.initialPage.props.__primary_menu;
        vueApp.config.globalProperties.$footerMenu1 = props.initialPage.props.__footer_menu_1;
        vueApp.config.globalProperties.$footerMenu2 = props.initialPage.props.__footer_menu_2;
        vueApp.config.globalProperties.$site = props.initialPage.props.__site;
        vueApp.config.globalProperties.$domain = props.initialPage.props.__domain;
        vueApp.config.globalProperties.$locale = props.initialPage.props.__locale;
        vueApp.config.globalProperties.$localeIcu = props.initialPage.props.__locale_icu;
        vueApp.config.globalProperties.$currency = props.initialPage.props.__currency;
        vueApp.config.globalProperties.$vatRate = props.initialPage.props.__vat_rate;
        vueApp.config.globalProperties.$cdnHost = props.initialPage.props.__cdn_host || 'https://imagedelivery.net';
        vueApp.config.globalProperties.$settings = props.initialPage.props.__settings;
        vueApp.config.globalProperties.$googleMapsApiKey = props.initialPage.props.__google_maps_api_key;
        vueApp.config.globalProperties.$sites = props.initialPage.props.__sites;
        vueApp.config.globalProperties.$globalColors = props.initialPage.props.__global_colors;
        vueApp.config.globalProperties.$globalFonts = props.initialPage.props.__global_fonts;
        vueApp.config.globalProperties.$globalMailboxStickerFigureCategories = props.initialPage.props.__global_mailbox_sticker_figure_categories;
        vueApp.config.globalProperties.$globalMailboxStickerFigures = props.initialPage.props.__global_mailbox_sticker_figures;
        vueApp.config.globalProperties.$globalStickerSetupSurfaces = props.initialPage.props.__global_sticker_setup_surfaces;
        vueApp.config.globalProperties.$algolia = props.initialPage.props.__algolia;

        moment.locale(vueApp.config.globalProperties.$locale);

        vueApp
            .mixin({ 
                methods: {
                    $route: (name, params, absolute, config = Ziggy) => route(name, params, absolute, config),
                    $cdn: (id, variant = 'public') => `${vueApp.config.globalProperties.$cdnHost}/hQS7qYjPZ4617TFkvQzxSw/${id}/${variant}`,
                    $date: (date, format = 'DD-MM-YYYY') => date ? moment(date).format(format) : '—',
                },
            })
            .mixin(require('../shared/translations'))
            .mixin(require('../shared/money'))
            .mixin(require('../shared/misc'))
            .mixin(require('../shared/scroll-lock'))

        const gtmUrl = vueApp.config.globalProperties.$settings.gtm_url || 'https://www.googletagmanager.com';
        const gtmId = vueApp.config.globalProperties.$settings.gtm_id;

        vueApp
            .use(plugin)
            .use(createGtm({
                id: gtmId,
                source: gtmUrl + '/gtm.js',
                defer: true,
                compatibility: false, 
                nonce: '2726c7f26c',
                enabled: !!gtmId, // Set to cookie variable. Build in listener for changes to cookie and use this.$gtm.enable(true/false)
                debug: false,
                loadScript: false,
                ignoredViews: [],
                trackOnNextTick: false,
            }))
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .mount(el)
    },
});